import React from 'react';
import { Box, Button, Stack } from '@mui/material';
import { styled } from '@mui/material/styles';
import ModeEditOutlineIcon from '@mui/icons-material/ModeEditOutline';
import DeleteIcon from '@mui/icons-material/Delete';
import LockResetIcon from '@mui/icons-material/LockReset';

const Item = styled(Box)(({ theme }) => ({
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'center',
}));

const ActionButtons = ({
  edit,
  remove,
  isInitPwd,
  handleEdit,
  handleRemove,
  handleInitPwd,
  editBtnText,
  editDelText,
}) => {
  return (
    <Stack direction="row" spacing={0.5}>
      {edit && (
        <Item>
          <Button
            color="info"
            variant="contained"
            startIcon={<ModeEditOutlineIcon />}
            onClick={handleEdit}
          >
            {editBtnText ? editBtnText : '수정'}
          </Button>
        </Item>
      )}
      {isInitPwd && (
        <Item>
          <Button
            color="secondary"
            variant="contained"
            startIcon={<LockResetIcon />}
            onClick={handleInitPwd}
          >
            비밀번호 초기화
          </Button>
        </Item>
      )}

      {remove && (
        <Item>
          <Button
            color="error"
            variant="contained"
            startIcon={<DeleteIcon />}
            onClick={handleRemove}
          >
            {editDelText ? editDelText : '삭제'}
          </Button>
        </Item>
      )}
    </Stack>
  );
};

export default ActionButtons;
